// src/pages/MainDashboard.js
import React, { useEffect, useState, useRef, useContext, useMemo } from "react";
import NavBarTop from '../../NavBar_Top/NavBar_Top';
import Rodape from '../../Rodape/Rodape';
// import ModalDadosPessoais from '../../Pages/MinhaConta/DadosPessoais';
import { BrowserView, MobileView } from 'react-device-detect';
import { ToastContainer, toast } from 'react-toastify';
import { Grid, Box } from "@material-ui/core";
import { TextField } from "@mui/material";
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import { MyContext } from '../../../context/MyContext';
import { useTheme, ThemeProvider, createTheme } from "@mui/material/styles";
import { DataGrid } from '@mui/x-data-grid';
import api from '../../../services/api';
import * as locales from '@mui/material/locale';
import { styled } from "@mui/material/styles";
import Paper from '@mui/material/Paper';
import { ReactComponent as UsuarioIcon } from '../../../assets/img/profileNAFIL.svg';
import { ReactComponent as ChaveIcon } from '../../../assets/img/chave.svg';
import OtpInput from "react-otp-input";
import axios from 'axios';
// import DashboardCadastro from '../../../components/Pages/Cadastro/Cadastro';
// import PaginaCadastro from '../../../components/Pages/Cadastro/Cadastro';
// import PaginaCadastro from '../../../components/CadastroUsuario/CadastroUsuario';
// import DashboardDadosPessoais from '../../../components/DadosPessoais/ModalDadosPessoais';
import ModalDadosPessoais from '../../../components/Pages/DadosPessoais/ModalDadosPessoais';
import ModalEnderecos from '../../../components/Pages/Enderecos/ModalEndereco';
import ModalContatos from '../../../components/Pages/Contatos/ModalContato';
import Typography from "@mui/material/Typography";
import { useNavigate, Link } from 'react-router-dom';
import Backdrop from '@mui/material/Backdrop';
import InputMask from 'react-input-mask';
import { useHistory } from 'react-router-dom';
import { minWidth } from "@mui/system";
import { useLocation } from 'react-router-dom';

//// import DashboardEndereco from '../../../components/Pages/MinhaConta/DashEndereco';
// import DashboardContato from "/NAFIL_/Site/dotNetFonte/SiteNafil-FrontEnd/src/components/Pages/MinhaConta/DashCadastro";
// import MinhaConta from './../MinhaContaOLD/MinhaConta';
// import { DashboardCadastro } from '/NAFIL_/Site/dotNetFonte/SiteNafil-FrontEnd/src/components/Pages/MinhaConta/DashCadastro';
// import DashCadastro from './../MinhaContaOLD/DashCadastro';
// import CadastroUsuario from './../../CadastroUsuario/CadastroUsuarioJoao';
// import CadastroUsuario from './../../CadastroUsuario/CadastroUsuarioJoao';
// import Contatos from './../MinhaContaOLD/ComponentesDoMenu/Contatos';
// <PaginaCadastro />

export default function MinhaConta(props) {
  const history = useHistory();
  const { nomeUsuarioLogado, setNomeUsuarioLogado } = useContext(MyContext); // Armazena Criptografado o Nome do Usuário Logado
  // const [nomeUsuarioLogado, setNomeUsuarioLogado] = useState(""); // Armazena Criptografado o Nome do Usuário Logado    
  // const [open, setOpen] = React.useState(false);
  // const [openDadosPessoais, setOpenDadosPessoais] = React.useState(false);
  const { openDadosPessoais, setOpenDadosPessoais } = useContext(MyContext);
  const [openMeusEnderecos, setOpenMeusEnderecos] = React.useState(false);
  const [openMeusContatos, setOpenMeusContatos] = React.useState(false);
  const [locale, setLocale] = useState('ptBR');
  const theme = useTheme();
  const themeWithLocale = useMemo(() => createTheme(theme, locales[locale]), [locale, theme]);
  const [email, setEmail] = useState('');
  const [reEmail, setReEmail] = useState('');
  const [cpf_cnpj, setCpf_Cnpj] = useState('');
  const [labelCpf_Cnpj, setLabelCpf_Cnpj] = useState("CPF:");
  const [maskCpf_Cnpj, setMaskCpf_Cnpj] = useState("999.999.999-99");
  const [ie_Rg, setIe_Rg] = useState('');
  const [razao_social, setRazao_Social] = useState('');
  const [existemErros, setExistemErros] = useState('');
  const [naoEditarFaturado, setNaoEditarFaturado] = useState(false);
  const [showingToast, setShowingToast] = useState(0);
  const [showingToastNeedLogin, setShowingToastNeedLogin] = useState(1);
  const { destinoPagina, setDestinoPagina } = useContext(MyContext);
  // const [usuarioLogado, setUsuarioLogado] = useState("");  // Armazena Criptografado o Id e Loja do Cliente  
  const { usuarioEfetuouLogin, setUsuarioEfetuouLogin } = useContext(MyContext);
  const { showModalDadosPessoais, setShowModalDadosPessoais } = useContext(MyContext);
  const { aguardandoCodigoVerificacao, setAguardandoCodigoVerificacao } = useContext(MyContext);
  const { usuarioEfetuouLoginEMail, setUsuarioEfetuouLoginEMail } = useContext(MyContext);
  const [editandoDadosPessoais, setEditandoDadosPessoais] = React.useState(false);
  const [exibirCodigoVefificacao, setExibirCodigoVefificacao] = React.useState(false);
  const [otp, setOtp] = React.useState("");
  const [codigoAcesso, setCodigoAcesso] = React.useState("");
  const [message, setMessage] = useState("Aguarde...");
  const location = useLocation();
  let navigate = useHistory();

  const handleChange = (value) => {
    if (/^[0-9]?$/.test(value)) {
      //const newCode = [...codigoAcesso];
      //newCode[index] = value;
      //setCode(newCode);

      // Foco automático no próximo campo
      //if (value && index < 5) {
      //   inputs.current[index + 1].focus();
      // }
      //setCodigoAcesso(value);
    }
    setOtp(value);
    setMessage("");
    setCodigoAcesso(value);
  };

  // useEffect(() => {
  //   if (showModalDadosPessoais == false || openDadosPessoais == false || aguardandoCodigoVerificacao == true){
  //   //  setExibirCodigoVefificacao(true);  
  //     console.log("VACA NOMEA", showModalDadosPessoais, openDadosPessoais, aguardandoCodigoVerificacao);
  //     navigate.push("/login");
  //   }
  //   else{      
  //      setOpenDadosPessoais(true);
  //      console.log("VACA NOMEZ", usuarioEfetuouLogin);
  //   }    
  // }, [showModalDadosPessoais]);

  useEffect(() => {
    if (openDadosPessoais == false && aguardandoCodigoVerificacao == true) {
      // setExibirCodigoVefificacao(true);  
      setDestinoPagina("verificacao");
      navigate.push("/login");
    }
    else if (openDadosPessoais == false && aguardandoCodigoVerificacao == true) {
      setExibirCodigoVefificacao(true);
      setDestinoPagina("verificacao");
      navigate.push("/verificacao");
    }
    else if (aguardandoCodigoVerificacao == true || openDadosPessoais == false || usuarioEfetuouLoginEMail == "") {
      setOpenDadosPessoais(false);
      setAguardandoCodigoVerificacao(true);
      setDestinoPagina("minha_conta");
      // VOLTAR navigate.push("/login");
    }
  }, []);

  // useEffect(() => {
  //   if (showModalDadosPessoais){
  //     console.log("VacaBBBB", showModalDadosPessoais, openDadosPessoais );
  //     return(
  //       <div>
  //         <ModalDadosPessoais />
  //       </div>
  //     );
  //   }    

  // }, [showModalDadosPessoais]); 


  // setUsuarioLogado(sessionStorage.getItem("id_loja_usuario"));
  // let usuarioComprasFaturado = sessionStorage.getItem("usuario_compras_faturado");
  // let usuarioLogado = sessionStorage.getItem("id_loja_usuario");

  // if (usuarioLogado != null && usuarioLogado != "" && usuarioLogado.length != 0){
  //   usuarioLogado = identificacaoUsuarioLogado(usuarioLogado);        
  // } 

  const toastMensagemErrorLogin = (message) => toast.error(message, { position: toast.POSITION.BOTTOM_CENTER, theme: "colored", autoClose: 2000 });

  const handleOpenDadosPessoais = () => {
    console.log("VACA ", showModalDadosPessoais);
    //if (showModalDadosPessoais == false){
    // BuscarMeusDadosPessoais();
    setShowModalDadosPessoais(true);
    //}
  }

  // const handleCloseDadosPessoais = () => {
  //   // setOpenDadosPessoais(false);
  //   setShowModalDadosPessoais(false);
  // }

  // const handleSalvarDadosPessoais = () => {
  //   if (razao_social == null || razao_social == "" || razao_social.length < 5){
  //     setExistemErros("Digite Seu Nome Completo...");
  //     return;
  //   }
  //   setOpenDadosPessoais(false);
  //   setShowModalDadosPessoais(false);
  // }

  const toastLoginSucesso = (nome) => toast.success("Bem Vindo, " + nome,
    { position: toast.POSITION.TOP_CENTER, theme: "colored", autoClose: 2000 });

  // const handleBotaoVerificar = async () => {
  //   try {     
  //     const res = await axios.post("https://whats.nafil.com.br/api/Acessos/verify-code", { usuarioEfetuouLoginEMail, codigoAcesso });
  //     if (res.data.success) {
  //       setMessage("Acesso autorizado!");
  //       toastLoginSucesso(nomeUsuarioLogado.split(' ').slice(0, 2).join(' '));
  //       setAguardandoCodigoVerificacao(false);
  //       setOpenDadosPessoais(true);
  //       setShowModalDadosPessoais(true);        
  //       console.log("NOMEY" , destinoPagina);
  //       if (destinoPagina === "faturado" && res?.data?.faturado != 1){
  //         navigate.push("/");                      
  //         return true;
  //       }

  //       if (destinoPagina){
  //           if ('/' + destinoPagina == location.pathname){
  //               navigate.replace('/' + destinoPagina);    
  //               window.location.reload();
  //           }
  //           else{
  //               navigate.push('/' + destinoPagina);
  //           }    
  //       }                  


  //       // Aqui você pode redirecionar para o dashboard protegido
  //     }
  //   } catch (err) {
  //     console.log("VACA 77777", err);
  //     setMessage(err.response?.data || " - Código Inválido.");
  //   }
  // };

  const handleOpenMeusEnderecos = () => {
    setOpenMeusEnderecos(true);
  }

  const handleCloseMeusEnderecos = () => {
    setOpenMeusEnderecos(false);
  }

  const handleOpenMeusContatos = () => {
    setOpenMeusContatos(true);
  }

  const handleCloseMeusContatos = () => {
    setOpenMeusContatos(false);
  }

  // function BuscarMeusDadosPessoais() {
  //   if (usuarioEfetuouLogin == null || usuarioEfetuouLogin == "" || usuarioEfetuouLogin.length == 0){
  //     return; 
  //   }
  //   if(usuarioEfetuouLogin.indexOf('_') == -1){
  //     return; 
  //   }
  //   api.get(`/Clientes/ClienteInfo/` + usuarioEfetuouLogin.split('_')[0] + `/` + usuarioEfetuouLogin.split('_')[1])
  //     .then((response) => {        
  //       if (response === null){
  //         return; 
  //       }
  //       console.log("VACA 1", showModalDadosPessoais, response);
  //       // setOpenDadosPessoais(response.data);
  //       setRazao_Social(response.data.nome);
  //       setCpf_Cnpj(response.data.cpf);
  //       setIe_Rg(response.data.ie_Rg);
  //       setEmail(response.data.contatos[0].email);
  //       setReEmail(response.data.contatos[0].email);

  //       // const [_cpf_cnpj, _setCpf_Cnpj] = useState('');
  //       // const [_ie_rg, _setIe_Rg] = useState('');
  //       // const [_razao_social, _setRazao_Social] = useState('');  
  //       // const [_senha, _setSenha] = useState('');  
  //       // const [_reSenha, _setreSenha] = useState('');  

  //       // setEditandoDadosPessoais(true);
  //       // setOpenDadosPessoais(true);
  //       // setShowModalDadosPessoais(true);
  //       // setOpenDadosPessoais(true);
  //     })
  //     .catch((error) => {
  //       console.log(error.message)
  //     });
  // }

  const style = {
    position: 'absolute',
    top: '25%',
    left: '10%',
    right: "10%",
    overflow: 'scroll',
    height: '100%',
    display: 'block',
    bgcolor: 'background.paper',
    boxShadow: 24
  }

  // const handleEmail = (e) => {
  //   setEmail(e.target.value);    
  // }

  // const handleReEmail = (e) => {
  //   setReEmail(e.target.value);
  // }

  // const handleCpfCnpj = (e) => {
  //   setCpf_Cnpj(e.target.value);
  // }

  // const handleIe_Rg = (e) => {
  //   setIe_Rg(e.target.value);
  // }

  // const handleRazao_Social = (e) => {
  //   setRazao_Social(e.target.value);
  // }  

  const handleBotaoCancelar = (e) => {
    setDestinoPagina('home');
    /// VOLTAR history.push("/home");    
  }

  // const handleBotaoReenviar = (e) => {
  //   if (usuarioEfetuouLoginEMail.length > 3){
  //     enviarCodigo(e);
  //   }    
  //   //sendCode();
  // }

  function mascararEmail(email, { userVisible = 1, domainVisible = 1, keepTLD = true, maskChar = "*" } = {}) {
    if (!email || typeof email !== "string") return "";

    const atIndex = email.lastIndexOf("@");
    if (atIndex === -1) return email;

    const local = email.slice(0, atIndex);
    const domainFull = email.slice(atIndex + 1);

    // separar domínio do TLD
    let domainName = domainFull;
    let tld = "";
    const lastDot = domainFull.lastIndexOf(".");
    if (lastDot > 0 && keepTLD) {
      domainName = domainFull.slice(0, lastDot);
      tld = domainFull.slice(lastDot);
    }

    // quantidade de caracteres a mascarar (garantindo >=0)
    const maskedLocalLength = Math.max(local.length - userVisible, 0);
    const maskedDomainLength = Math.max(domainName.length - domainVisible, 0);

    const maskedLocal = maskChar.repeat(maskedLocalLength);
    const maskedDomain = maskChar.repeat(maskedDomainLength);

    const visibleLocal = local.slice(0, userVisible);
    const visibleDomain = domainName.slice(0, domainVisible);

    return `${visibleLocal}${maskedLocal}@${visibleDomain}${maskedDomain}${tld}`;
  }

  const deslogar = async (event) => {
    sessionStorage.removeItem("nome_razao_social_logado");
    sessionStorage.removeItem("nome_usuario_logado");
    sessionStorage.removeItem("id_loja_usuario");
    sessionStorage.removeItem("hash_usuario");
    sessionStorage.removeItem("usuario_compras_faturado");
    setUsuarioEfetuouLogin("");
    setNomeUsuarioLogado("");
    setUsuarioEfetuouLogin("");
    setUsuarioEfetuouLoginEMail("");
    setOpenDadosPessoais(false);
    history.push('/index');
    api.post(`/Login/logout`, {}, { withCredentials: true })
      .then((response) => {
        history.push('/index');
        // console.log("REsP ", response); 
      })
      .catch((error) => {
        // console.log("REsP Ruim ", error);
        if (error == "Error: Network Error") {
          toastMensagemError("Ops, Alguma Coisa Errada com Nosso Servidor!");
          return null;
        }
      });

    // 02/09/2023  setAtualizarPagina(true); 
  }

  const travado = () => {
    if (showingToast === 0) {
      setShowingToast(1);
      setDestinoPagina("home");
      toastMensagemError("SOMENTE PARA CLIENTES FATURADOS!");
      /// VOLTAR history.push("/");
      return;
    }
  }

  const needLogin = () => {
    if (showingToast === 0) {
      setShowingToast(1);
      setDestinoPagina("verificacao");
      toastMensagemErrorLogin("NECESSÁRIO EFETUAR LOGIN!");
      /// VOLTAR  history.push("/login");
      // return;
    }
  }

  // const liberado = () => {
  //   if (usuarioEfetuouLogin === null || usuarioEfetuouLogin === "" || usuarioEfetuouLogin.length === 0)
  //   { 
  //     setShowingToastNeedLogin(1);
  //     setAguardandoCodigoVerificacao(false)
  //     // needLogin();
  //     return (
  //       <div>          
  //         <Rodape />
  //       </div>
  //     )
  //   }
  //   else{
  //     return (
  //       <div>
  //         <MeusDadosPessoais />
  //         <Rodape />
  //       </div>
  //     )
  //   }   
  // }

  function identificacaoUsuarioLogado() {
    if (sessionStorage.getItem("id_loja_usuario") == null || sessionStorage.getItem("id_loja_usuario") == "") {
      return "";
    }
    return (Buffer.from(sessionStorage.getItem("id_loja_usuario").replace('YfhR7sFdS53a==', '').substring(2), 'base64').toString());
  }

  const toastMensagemError = (message) => toast.error(message,
    { position: toast.POSITION.TOP_CENTER, theme: "colored", autoClose: 2000 });

  // const ModalDadosPessoais = () => {
  //   setDestinoPagina("minha_conta");
  //   return (
  //     <div>
  //       {/*  <NavBarTop />
  //       <ToastContainer /> */}        
  //       {          
  //         (usuarioEfetuouLogin != null && usuarioEfetuouLogin != "" ?            
  //            liberado()            
  //           :
  //            needLogin()
  //         )}      
  //     </div>
  //   )
  // }

  // console.log("JOAO ", usuarioEfetuouLogin);
  // if (usuarioEfetuouLogin == null || usuarioEfetuouLogin != "" || usuarioEfetuouLogin.length == 0){
  //   return (<div></div>);
  // }


  const sendCode = async () => {
    try {
      const res = await axios.post("https://whats.nafil.com.br/api/Acessos/send-code", { usuarioEfetuouLoginEMail });
      setMessage(res.data.message);

      console.log("VACAAA", res.data.message);

    } catch (err) {
      setMessage(err.response?.data || "Erro ao enviar código.");
      console.log("VACAAAB", err.response?.data || "Erro ao enviar código.");
    }
  };

  const enviarCodigo = async () => {
    try {
      // monta o objeto JSON
      const data = { "Email": usuarioEfetuouLoginEMail };

      // envia para a API
      const response = await axios.post("https://whats.nafil.com.br/api/Acessos/send-code", data, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      setMessage("Código enviado com sucesso!");
      console.log("VACAC", response.data);
    } catch (error) {
      console.log("VACAD", error);
      setMessage(
        error.response?.data || "Ocorreu um erro ao enviar o código"
      );
    }
  };

  // const MeusDadosPessoais = () => {

  //   // if (editandoDadosPessoais == false){
  //   //   console.log("VaCa 2");
  //   //   return;
  //   // }    

  //   // if (openDadosPessoais == false || editandoDadosPessoais == false){
  //   //    console.log("VaCa 3");
  //   //    return;
  //   // }        
  console.log("VaCa 4", showModalDadosPessoais);

  return (
    <div>
      {openDadosPessoais == false || aguardandoCodigoVerificacao == true || usuarioEfetuouLoginEMail.length < 4
        ?
        <div></div>
        :
        <div>
          <BrowserView>
            <NavBarTop />

            <Grid container justify="center">
              <Box sx={{
                display: 'flex',
                flexWrap: 'wrap',
                '& > :not(style)': {
                  m: 1,
                  width: '90%',
                  height: '100%',
                },
                alignContent: 'center',
                justifyContent: 'center',
                marginTop: '100px',
                marginBottom: '100px',
              }}
              >
                <Paper elevation={1} style={{ backgroundColor: '#f5f5dc', height: "100%", marginTop: "10px" }}>
                  <Grid container>
                    <Grid item xs={6} sx={{ height: "100vh" }}>
                      <UsuarioIcon style={{ color: "green", width: "180px", height: "180px", marginTop: "45px" }} />
                    </Grid>
                    <Grid item xs={6}>
                      <Grid container>
                        <Grid item xs={12}>
                          <Box sx={{ marginTop: "5px", marginLeft: "65px" }}>
                            <ModalDadosPessoais props={usuarioEfetuouLogin} />
                          </Box>
                        </Grid>
                        <Grid item xs={12} sx={{ display: "flex", justifyContent: "center", alignItems: "center" }} style={{ marginTop: '2px' }}>
                          <Box sx={{ marginTop: "5px", marginLeft: "65px" }}>
                            <ModalEnderecos props={usuarioEfetuouLogin} />
                          </Box>
                        </Grid>
                        <Grid item xs={12}>
                          <Box sx={{ marginTop: "25px", marginLeft: "65px" }}>
                            <ModalContatos props={usuarioEfetuouLogin} sx={{ minWidth: "257px" }} />
                          </Box>
                        </Grid>
                        <Grid item xs={12}>
                          <Button variant="contained" onClick={(e) => deslogar(e)} style={{ backgroundColor: '#357a38', marginTop: '30px', marginBottom: '25px', minWidth: "192px", maxHeight: "25px" }}>Efetuar Logoff</Button>
                        </Grid>
                      </Grid>
                    </Grid>

                  </Grid>
                </Paper>
              </Box>
            </Grid>
            <Rodape />
          </BrowserView>

          <MobileView>
            <NavBarTop />

            <Grid container justify="center">
              <Box sx={{
                display: 'flex',
                flexWrap: 'wrap',
                '& > :not(style)': {
                  m: 1,
                  width: '95%',
                  height: '100%',
                },
                alignContent: 'center',
                justifyContent: 'center',
                marginTop: '100px',
                marginBottom: '100px',
              }}
              >
                <Paper elevation={1} style={{ backgroundColor: '#f5f5dc', height: "100%", marginTop: "10px" }}>
                  <Grid container>
                    <Grid item xs={6} sx={{ height: "100vh" }}>
                      <UsuarioIcon style={{ color: "green", width: "142px", height: "142px", marginTop: "45px" }} />
                    </Grid>
                    <Grid item xs={6}>
                      <Grid container>
                        <Grid item xs={12}>
                          <Box sx={{ marginTop: "5px", marginRight: "5px" }}>
                            <ModalDadosPessoais props={usuarioEfetuouLogin} />
                          </Box>
                        </Grid>
                        <Grid item xs={12} sx={{ display: "flex", justifyContent: "center", alignItems: "center" }} style={{ marginTop: '2px' }}>
                          <Box sx={{ marginTop: "5px", marginLeft: "45px" }}>
                            <ModalEnderecos props={usuarioEfetuouLogin} />
                          </Box>
                        </Grid>
                        <Grid item xs={12}>
                          <Box sx={{ marginTop: "25px", marginLeft: "45px" }}>
                            <ModalContatos props={usuarioEfetuouLogin} sx={{ minWidth: "257px" }} />
                          </Box>
                        </Grid>
                        <Grid item xs={12}>
                          <Button variant="contained" onClick={(e) => deslogar(e)} style={{ backgroundColor: '#357a38', marginTop: '30px', marginBottom: '25px', minWidth: "170px", maxWidth: "170px", maxHeight: "25px", marginRight: "5px" }}>Logoff</Button>
                        </Grid>
                      </Grid>
                    </Grid>

                  </Grid>
                </Paper>
              </Box>
            </Grid>
            <Rodape />

          </MobileView>

          <ToastContainer />

          {/* <ModalDadosPessoais /> */}

          {/* <ModalContatos /> */}
        </div>
      }
    </div>
  );

}
